import { createContext, useContext } from 'react';

const FieldDefsContext = createContext({ fieldDefs: null });

export const FieldDefsProvider = ({ fieldDefs, children }) => {
  return <FieldDefsContext.Provider value={{ fieldDefs }}>{children}</FieldDefsContext.Provider>;
};

export const useFieldDefs = () => useContext(FieldDefsContext);
